import * as React from "react";
import { motion } from "motion/react";
import { ReorderButton, CartButton } from "@grandvisionhq/common";
import { Icon } from "@grandvisionhq/icons";
import { useFeatureToggles } from "@grandvisionhq/state";
import { CountrySwitcherMenu } from "../../../../../../CountrySwitcherMenu/CountrySwitcherMenu/CountrySwitcherMenu.js";
/* empty css            */
const buttonContainer = {
  show: {
    opacity: 1,
    transition: {
      ease: "easeOut",
      duration: 0.3
    }
  },
  hide: {
    opacity: 0,
    transition: {
      duration: 0
    }
  }
};
const Header = ({
  activeSubMenu,
  backLabel,
  closeLabel,
  countrySwitcherOptions,
  hideSubMenu,
  hideSiteNav,
  isOpen,
  routes,
  renderCartButton,
  renderWishlistMenuItem,
  ordersUrl
}) => {
  const { isReorderButtonEnabled } = useFeatureToggles();
  return /* @__PURE__ */ React.createElement("div", { className: "site-nav-mobile__header" }, isOpen && /* @__PURE__ */ React.createElement(
    motion.button,
    {
      animate: activeSubMenu ? "show" : "hide",
      "aria-label": backLabel,
      className: "site-nav-mobile__back-button",
      onClick: hideSubMenu,
      variants: buttonContainer,
      "aria-hidden": activeSubMenu === "",
      tabIndex: isOpen && activeSubMenu !== "" ? void 0 : -1
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, { name: "chevron-left" }))
  ), countrySwitcherOptions && /* @__PURE__ */ React.createElement(
    CountrySwitcherMenu,
    {
      className: "site-nav-mobile__icon",
      options: isOpen ? countrySwitcherOptions : [],
      tabIndex: isOpen ? void 0 : -1,
      ariaHidden: !isOpen
    }
  ), isReorderButtonEnabled && ordersUrl && /* @__PURE__ */ React.createElement(ReorderButton, { tabIndex: isOpen ? void 0 : -1, "aria-hidden": !isOpen, url: ordersUrl }), renderWishlistMenuItem ? renderWishlistMenuItem(
    {
      label: ""
    },
    isOpen ? void 0 : -1
  ) : /* @__PURE__ */ React.createElement(
    "a",
    {
      className: "site-nav-mobile__icon",
      href: routes.stores,
      tabIndex: isOpen ? void 0 : -1
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "location" })
  ), renderCartButton ? renderCartButton(
    {
      label: "",
      link: { href: routes.cart, type: "internal" }
    },
    isOpen ? void 0 : -1
  ) : /* @__PURE__ */ React.createElement(
    CartButton,
    {
      className: "site-nav-mobile__icon site-nav-mobile__cart",
      href: routes.cart,
      tabIndex: isOpen ? void 0 : -1
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "site-nav-mobile__icon site-nav-mobile__close",
      onClick: hideSiteNav,
      "aria-label": closeLabel,
      tabIndex: isOpen ? void 0 : -1
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "close" })
  ));
};
export {
  Header as default
};
//# sourceMappingURL=Header.js.map
